import {
  designSystemTokenValues as token,
  designSystemVars as vars,
} from "../tokens";

export interface CircularProgressProps {
  size?: number;
  strokeWidth?: number;
  percentage: number;
  showInsidePercentage?: boolean;
  fontSize?: number;
}

export const CircularProgress = ({
  size = 22,
  strokeWidth = 5,
  percentage,
  showInsidePercentage = false,
  fontSize = Number.parseFloat(token.typography.size.lg),
}: CircularProgressProps) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = (percentage / 100) * circumference;

  const getColors = () => {
    if (percentage >= 80) {
      return {
        fillColor: vars.color.dataVisualization.score.excellent,
        bgColor: vars.color.feedback.success.background,
      };
    }

    if (percentage >= 60) {
      return {
        fillColor: vars.color.dataVisualization.score.good,
        bgColor: vars.color.feedback.success.background,
      };
    }

    if (percentage >= 40) {
      return {
        fillColor: vars.color.dataVisualization.score.caution,
        bgColor: vars.color.dataVisualization.score.cautionBackground,
      };
    }

    if (percentage >= 20) {
      return {
        fillColor: vars.color.dataVisualization.score.poor,
        bgColor: vars.color.feedback.error.background,
      };
    }

    return {
      fillColor: vars.color.control.errorText,
      bgColor: vars.color.feedback.error.background,
    };
  };

  const { fillColor, bgColor } = getColors();

  return (
    <svg width={size} height={size}>
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={bgColor}
        strokeWidth={strokeWidth}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={fillColor}
        strokeWidth={strokeWidth}
        strokeDasharray={circumference}
        strokeDashoffset={circumference - progress}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
      {showInsidePercentage && (
        <text
          x="53%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="central"
          fontSize={fontSize}
          fontWeight={vars.typography.weight.semibold}
          fill={fillColor}
        >
          {Math.round(percentage)}%
        </text>
      )}
    </svg>
  );
};
